const getSelectedRowIds = (currentState, selectAll) => {
  return selectAll ? [] : currentState.selectedRowsIds;
};
export default getSelectedRowIds;
